import { Spin } from 'antd';

import { Props } from './Spinner.model';

import styles from './Spinner.module.scss';

const Spinner = ({
	className,
	delay = 500,
	size = 'large',
	spinning = false,
	fixed = true
}: Props) => {
	let wrapperClassName = `${styles.wrapper} ${className || ''} ${fixed ? styles.fixed : ''}`;

	if (spinning) {
		wrapperClassName = `${wrapperClassName} ${styles.spinning}`
	}

	return (
		<div className={wrapperClassName}>
			<div className={styles.spinBackdrop}></div>
			<Spin className={styles.spinner} size={size} spinning={spinning} delay={delay}/>
		</div>
	);
}

export default Spinner;